// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1__yw","cls2":"SimplePaperPodcast-cls2_JYN SimplePaperPodcast-cls1__yw"};